module.exports = __webpack_public_path__ + "static/img/bg_2.39dcaff0.jpg";